export const myCartRoutes = {
  path: "/my-cart",
  children: [
    {
      index: true,
      async lazy() {
        const { Component, loader } = await import("./lazyRoute.ts");
        return { Component, loader };
      },
    },
    {
      path: "/my-cart/:cartItemId",
      async lazy() {
        const { update } = await import("./lazyRoute.ts");
        return { action: update };
      },
    },
  ],
};
